import strings from "./AssistanceSummary.strings";
import { useStrings } from "features/i18n/useStrings";
import "./AssistanceSummary.less";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "app/hooks";
import { selectQuestionsWithAssistance } from "features/qualityForm/qualityFormSlice";
import { GuxIcon } from "genesys-spark-components-react";
import { selectIsQuestionHavingValidAssistedConditions } from "features/qualityForm/qualityFormValidations";
import { ErrorStatement } from "../common/ErrorStatement/ErrorStatement";

export function AssistanceSummary() {
    const t = useStrings(strings);
    const {
        totalQuestions,
        totalQuestionsWithAssistance,
        questionsWithInvalidAssistanceConfig,
    } = useAppSelector((state) => {
        const totalQuestions = Object.keys(
            state.qualityForm.data.questions ?? {}
        ).length;
        const questionIdsWithAssistance = selectQuestionsWithAssistance(state);
        const totalQuestionsWithAssistance =
            questionIdsWithAssistance?.length ?? 0;
        const questionsWithInvalidAssistanceConfig =
            questionIdsWithAssistance.filter(
                (id) =>
                    !selectIsQuestionHavingValidAssistedConditions(state, id)
            )?.length ?? 0;
        return {
            totalQuestions,
            totalQuestionsWithAssistance,
            questionsWithInvalidAssistanceConfig,
        };
    }, shallowEqual);
    return (
        <div className="AssistanceSummary">
            <span className="heading">{t.labels.heading}</span>
            <div className="body">
                <div className="config-summary">
                    <GuxIcon
                        icon-name="quote-left"
                        screenreader-text={t.labels.assistanceIcon}
                        decorative={true}
                    ></GuxIcon>
                    <span>
                        {t.summary({
                            questionsConfiguredWithAssistance:
                                totalQuestionsWithAssistance,
                            totalQuestionCount: totalQuestions,
                            entity:
                                totalQuestions === 1
                                    ? t.labels.question
                                    : t.labels.questions,
                        })}
                    </span>
                </div>
                {questionsWithInvalidAssistanceConfig > 0 && (
                    <ErrorStatement
                        errorMessage={t.invalidConditions({
                            invalidConditions:
                                questionsWithInvalidAssistanceConfig,
                            entity:
                                questionsWithInvalidAssistanceConfig === 1
                                    ? t.labels.condition
                                    : t.labels.conditions,
                        })}
                    />
                )}
            </div>
        </div>
    );
}
